import {
  EDUCATOR_ROLE_DETAILS,
  getEducatorPurchaseContent,
  getEducatorRoleLabel,
} from '../handbookProducts.js';

const DEFAULT_ROLE = 'shadow-teacher';

function readChildName() {
  try {
    const answers = JSON.parse(
      localStorage.getItem('gentle_connections_answers') || '{}',
    );
    return String(answers.childName || '').trim();
  } catch {
    return '';
  }
}

function renderRoleCards(activeRole) {
  return EDUCATOR_ROLE_DETAILS.map(
    (role) => `
    <button
      type="button"
      class="product-role-card${role.value === activeRole ? ' active' : ''}"
      data-role="${role.value}"
    >
      <span class="product-role-icon" aria-hidden="true">${role.icon}</span>
      <span class="product-role-name">${role.shortName}</span>
      <span class="product-role-meta">${getEducatorPurchaseContent(role.value).badge}</span>
    </button>
  `,
  ).join('');
}

function renderDetail(role, childName = '') {
  const content = getEducatorPurchaseContent(role);
  const label = getEducatorRoleLabel(role);
  const childLead = childName ? `for ${childName}` : 'for your child';
  const ctaLabel = childName
    ? `Start ${childName}'s handbook`
    : 'Start your handbook';
  return `
    <div class="product-role-story">
      <span class="purchase-badge">${content.badge}</span>
      <h2>${content.title}</h2>
      <p class="product-role-intro">${content.intro}</p>
      <p class="product-role-summary">${content.summary}</p>
      <p class="product-role-problem">${content.problem}</p>
      <p class="product-role-summary">This version is shaped specifically ${childLead}, with language and guidance tuned for the ${label.toLowerCase()}.</p>
    </div>
    <div class="product-role-columns">
      <section class="product-role-panel">
        <div class="purchase-detail-label">Why This Version Helps</div>
        <ul class="purchase-value-props">
          ${content.valueProps.map((item) => `<li>${item}</li>`).join('')}
        </ul>
      </section>
      <section class="product-role-panel">
        <div class="purchase-detail-label">What This Adult Can Act On</div>
        <ul class="purchase-outcome-list compact">
          ${content.outcomes.map((item) => `<li>${item}</li>`).join('')}
        </ul>
      </section>
    </div>
    <section class="product-included-panel">
      <div class="purchase-detail-label">What Every Handbook Includes</div>
      <div class="product-included-grid">
        <article class="section-card">
          <h3>Role-specific guidance</h3>
          <p>A full handbook written for the ${label.toLowerCase()}, not a generic school document.</p>
        </article>
        <article class="section-card">
          <h3>Actionable sections</h3>
          <p>The current default handbook structure, shaped by the parent’s answers and ready to use in real situations.</p>
        </article>
        <article class="section-card">
          <h3>Generate on demand</h3>
          <p>The parent can generate and download a fresh PDF when needed. Finished PDFs are not stored.</p>
        </article>
      </div>
    </section>
    <div class="product-role-cta">
      <a href="/app.html" class="btn btn-primary btn-large">${ctaLabel}</a>
      <p>Each purchase is for one child and one educator-specific handbook.</p>
    </div>
  `;
}

function mountProductPage(root) {
  let activeRole = DEFAULT_ROLE;
  const childName = readChildName();
  const cards = root.querySelector('[data-role-cards]');
  const detail = root.querySelector('[data-role-detail]');

  const render = () => {
    cards.innerHTML = renderRoleCards(activeRole);
    detail.innerHTML = renderDetail(activeRole, childName);
  };

  cards.addEventListener('click', (event) => {
    const button = event.target.closest('[data-role]');
    if (!button) return;
    activeRole = button.getAttribute('data-role') || DEFAULT_ROLE;
    render();
  });

  render();
}

const root = document.querySelector('[data-product-page]');
if (root) mountProductPage(root);
